export default __webpack_public_path__ + "static/media/tiered.dbb20ac0.svg";